import React, { useState, useEffect } from 'react';

export enum VideoProvider {
    DAM = "DAM",
    YOUTUBE = "YOUTUBE",
    VIMEO = "VIMEO",
}

interface VideoProps {
    videoItem: {
        provider: string;
        id?: string;
        url?: string;
        thumbnail?: string;
    }
    isPlaying: boolean;
    onPlay: () => void;
}

const Video: React.FC<VideoProps> = ({ videoItem, isPlaying, onPlay }) => {
    const {id, provider, thumbnail} = videoItem;
    const [isPlayingState, setIsPlayingState] = useState(false);
    useEffect(() => {
        setIsPlayingState(isPlaying);
    }, [isPlaying]);

    const handlePlay = (provider, id) => {
        setIsPlayingState(true);
        setTimeout(() => {
            if (provider === VideoProvider.YOUTUBE || provider === VideoProvider.VIMEO) {
                const video = document.querySelector(`.slick-active iframe[src*="${id}"]`) as HTMLIFrameElement;
                if (video) {
                    const videoSrc = video.getAttribute("src");
                    const separator = videoSrc.includes("?") ? "&" : "?";
                    video.setAttribute("src", `${videoSrc}${separator}autoplay=1`);
                }
            } else if (provider === VideoProvider.DAM) {
                const video = document.querySelector(`.slick-active video[data-src="${id}"]`) as HTMLVideoElement;
                if (video) {
                    video.play();
                }
            }
        }, 0);
        onPlay();
    };

    let thumbnailUrl = '';
    switch (provider) {
        case VideoProvider.YOUTUBE:
            thumbnailUrl = `https://img.youtube.com/vi/${id}/maxresdefault.jpg`;
            break;
        case VideoProvider.VIMEO:   
            thumbnailUrl = `https://vumbnail.com/${id}.jpg`;
            break;
        default:
            thumbnailUrl = thumbnail;
            break;
    }

    const embedUrl = provider === VideoProvider.YOUTUBE
        ? `https://www.youtube.com/embed/${id}`
        : provider === VideoProvider.VIMEO
        ? `https://player.vimeo.com/video/${id}`
        : '';

    const videoElement = provider === VideoProvider.DAM
        ? <video width="640" height="360" tabIndex={-1}
                    className="cmp-teaser__video-element"
                    controls
                    data-src={id}>
                <source src={id} type="video/mp4" />
                Your browser does not support the video tag.
            </video> :
        <iframe src={embedUrl} 
            frameBorder="0" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen 
            title={`${provider} video`}/>;

    return (
        <>
            {!isPlayingState ? (
                <div className="main-media__thumbnail" onClick={() => handlePlay(provider, id)}>
                    <img src={thumbnailUrl} alt="Video Thumbnail" />
                    <span className="play-button svg-play-with-circle-white"/>
                </div>
            ) : (
                videoElement
            )}
        </>
    );
};

export default Video;